import { hasFileExtension } from './hasFileExtension.js';

const videoFileExtensions = ['.mp4', '.webm', '.ogg', '.mov'];

export const isVideo = (url: string) => {
  return hasFileExtension(url, videoFileExtensions);
};
